import { render, staticRenderFns } from "./PosMenota.vue?vue&type=template&id=b89224f2&scoped=true&"
import script from "./PosMenota.vue?vue&type=script&lang=js&"
export * from "./PosMenota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b89224f2",
  null
  
)

export default component.exports